export const FETCH_PATTERN_SUMMARY_REQUEST = 'FETCH_PATTERN_SUMMARY_REQUEST';
export const FETCH_PATTERN_SUMMARY_SUCCESS = 'FETCH_PATTERN_SUMMARY_SUCCESS';
export const FETCH_PATTERN_SUMMARY_FAILURE = 'FETCH_PATTERN_SUMMARY_FAILURE';

export const FETCH_PATTERNS_REQUEST = 'FETCH_PATTERNS_REQUEST';
export const FETCH_PATTERNS_SUCCESS = 'FETCH_PATTERNS_SUCCESS';
export const FETCH_PATTERNS_FAILURE = 'FETCH_PATTERNS_FAILURE';

export const FETCH_PATTERN_CLAIMS_REQUEST = 'FETCH_PATTERN_CLAIMS_REQUEST';
export const FETCH_PATTERN_CLAIMS_SUCCESS = 'FETCH_PATTERN_CLAIMS_SUCCESS';
export const FETCH_PATTERN_CLAIMS_FAILURE = 'FETCH_PATTERN_CLAIMS_FAILURE';
